import { useEffect, useState } from "react";
import Product3DViewer from "./Product3DViewer";
import styles from "./Product3DViewerWithModal.module.css";

const Product3DViewerWithModal = ({ src, title }) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = event => {
            if (event.key === "Escape") {
                setIsOpen(false);
            }
        };

        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", handleKeyDown);

        return () => {
            document.body.style.overflow = "";
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen]);

    if (!src) return null;

    return (
        <>
            <div className={styles.inlineViewer}>
                <Product3DViewer src={src} title={title} />

                <button
                    type="button"
                    className={styles.fullscreenButton}
                    onClick={() => setIsOpen(true)}
                >
                    Full Screen 3D
                </button>
            </div>

            {isOpen && (
                <div className={styles.modalOverlay} role="dialog" aria-modal="true">
                    <div className={styles.modalViewer}>
                        <div className={styles.modalViewerHeader}>
                            <p>{title || "LG RetailVerse 3D Viewer"}</p>

                            <button
                                type="button"
                                className={styles.closeButton}
                                onClick={() => setIsOpen(false)}
                                aria-label="Close full screen 3D viewer"
                            >
                                ×
                            </button>
                        </div>

                        <div className={styles.modalViewerBody}>
                            <Product3DViewer src={src} title={title} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Product3DViewerWithModal;


// import { useEffect, useState } from "react";
// import Product3DViewer from "./Product3DViewer";
// import styles from "./Product3DViewerWithModal.module.css";

// const Product3DViewerWithModal = ({ src, title, onFallback }) => {
//     const [isOpen, setIsOpen] = useState(false);

//     useEffect(() => {
//         if (!isOpen) return;

//         const handleKeyDown = (event) => {
//             if (event.key === "Escape") {
//                 setIsOpen(false);
//             }
//         };

//         document.body.style.overflow = "hidden";
//         window.addEventListener("keydown", handleKeyDown);

//         return () => {
//             document.body.style.overflow = "";
//             window.removeEventListener("keydown", handleKeyDown);
//         };
//     }, [isOpen]);

//     if (!src) return null;

//     return (
//         <>
//             <div className={styles.inlineViewer}>
//                 <Product3DViewer
//                     src={src}
//                     title={title}
//                     onFallback={onFallback}
//                 />

//                 <button
//                     type="button"
//                     className={styles.fullscreenButton}
//                     onClick={() => setIsOpen(true)}
//                 >
//                     Full Screen 3D
//                 </button>
//             </div>

//             {isOpen && (
//                 <div className={styles.modalOverlay} role="dialog" aria-modal="true">
//                     <div className={styles.modalViewer}>
//                         <div className={styles.modalViewerHeader}>
//                             <p>{title || "LG RetailVerse 3D Viewer"}</p>

//                             <button
//                                 type="button"
//                                 className={styles.closeButton}
//                                 onClick={() => setIsOpen(false)}
//                                 aria-label="Close full screen 3D viewer"
//                             >
//                                 ×
//                             </button>
//                         </div>

//                         <div className={styles.modalViewerBody}>
//                             <Product3DViewer
//                                 src={src}
//                                 title={title}
//                                 onFallback={onFallback}
//                             />
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

// export default Product3DViewerWithModal;